"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyDocumentSectionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var DocumentListModal_1 = require("../annual/motor/DocumentListModal");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../commonFunctions");
var services_1 = require("@falcon/services");
var PolicyDocumentSectionWidget = /** @class */ (function (_super) {
    __extends(PolicyDocumentSectionWidget, _super);
    function PolicyDocumentSectionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToEditRenewal = _this.navigateToEditRenewal.bind(_this);
        return _this;
    }
    PolicyDocumentSectionWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "policy-document-section-widget mb-5", children: this.renderPolicyDocumentSection() }));
    };
    PolicyDocumentSectionWidget.prototype.renderPolicyDocumentSection = function () {
        var _a, _b;
        var documentVersion = (0, DocumentListModal_1.getDocumentVersionByDate)(((_b = (_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.factors) === null || _b === void 0 ? void 0 : _b.renewalQuoteDate)
            ? new Date(this.props.interaction.factors.renewalQuoteDate)
            : new Date(this.props.interaction.factors.originalQuoteDate));
        var docTitle = (0, commonFunctions_1.getMotorDOITitle)(documentVersion);
        return ((0, jsx_runtime_1.jsxs)("p", { children: ["Open the ", (0, jsx_runtime_1.jsx)("a", { target: "_blank", download: docTitle, href: "/resources/documents/LV_".concat(services_1.resourcesHelper.THEME, "_Annual_Car/").concat(documentVersion, "/LV_").concat(services_1.resourcesHelper.THEME, "_Annual_Car_DOI_").concat(documentVersion, ".pdf"), children: "policy document" }), " to see full cover details"] }));
    };
    PolicyDocumentSectionWidget.prototype.navigateToEditRenewal = function () {
        journey_services_1.ObjectManipulator.setField("uistate.interactionChangesDetected", this.props.interaction, true);
        this.props.engine.navigate("viewAndEditRenewalProposalPage", false);
    };
    return PolicyDocumentSectionWidget;
}(plugin_journey_1.WidgetBase));
exports.PolicyDocumentSectionWidget = PolicyDocumentSectionWidget;
//# sourceMappingURL=PolicyDocumentSectionWidget.js.map